import React, { FC } from 'react'

import { ContractTerms } from '~/gql/graphql'
import { useInBucket } from '~/hooks/use-in-bucket'

import styles from './styles.module.css'

interface SmallPrintProps {
  contractTerms: ContractTerms
}

const SmallPrint: FC<SmallPrintProps> = ({ contractTerms }) => {
  const simplifySmallPrint = useInBucket('experiment-broadband-asa-contract-pricing-extended', 'lightweight')

  if (contractTerms.isFixedContract) return null

  return (
    <div className={styles.smallPrint}>
      {simplifySmallPrint ? 'monthly cost may rise during contract' : contractTerms.priceRiseText}
    </div>
  )
}

export default SmallPrint
